import { Link } from "react-router-dom";
import type { ReactElement, ReactNode } from "react";

// The dark-themed centered card used by the auth pages. Reuses the landing's
// background orbs + brand for visual continuity.
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}): ReactElement {
  return (
    <div className="auth-shell">
      <div className="bg-orbs" aria-hidden="true">
        <div className="bg-orb bg-orb-1" />
        <div className="bg-orb bg-orb-2" />
      </div>
      <div className="auth-card">
        <Link to="/" className="auth-brand">
          <span className="nav-brand-name">FaceAge</span>
        </Link>
        <h1 className="auth-title">{title}</h1>
        <p className="auth-subtitle">{subtitle}</p>
        {children}
      </div>
    </div>
  );
}
